import { createContext, useContext, useMemo } from 'react';
import { SchedulePulseInsuranceTabProps } from '../components/SchedulePulseInsuranceTab';

const SchedulePulseInsuranceTabContext = createContext<SchedulePulseInsuranceTabProps>({
  defaultAppointmentList: [],
  getScopeName: () => '',
  selectedLocationIds: [],
  selectedDate: '',
  setSelectedDate: () => {},
  isMultiLocation: false,
});

type SchedulePulseInsuranceTabProviderProps = SchedulePulseInsuranceTabProps & {
  children: React.ReactNode;
  setShouldRenderInsuranceAnalysis: (value: boolean) => void;
};

export const SchedulePulseInsuranceTabProvider = ({
  defaultAppointmentList,
  getScopeName,
  selectedDate,
  setSelectedDate,
  selectedLocationIds,
  children,
  isMultiLocation,
  setShouldRenderInsuranceAnalysis,
}: SchedulePulseInsuranceTabProviderProps) => {
  const providerValue = useMemo(
    () => ({
      defaultAppointmentList,
      getScopeName,
      selectedDate,
      selectedLocationIds,
      setSelectedDate,
      isMultiLocation,
      setShouldRenderInsuranceAnalysis,
    }),
    [
      defaultAppointmentList,
      getScopeName,
      selectedDate,
      selectedLocationIds,
      setSelectedDate,
      isMultiLocation,
      setShouldRenderInsuranceAnalysis,
    ]
  );

  return (
    <SchedulePulseInsuranceTabContext.Provider value={providerValue}>
      {children}
    </SchedulePulseInsuranceTabContext.Provider>
  );
};

export const useSchedulePulseInsuranceTabContext = () => useContext(SchedulePulseInsuranceTabContext);
